import { useMutation } from '@tanstack/react-query';
import { logger } from '@dist-marketplace-frontend/services';
import { dealerApi } from '../../../../api/dealerApi';

export const useRevealDealerPhoneMutation = () => {
  return useMutation({
    mutationFn: (dealerId: string) =>
      dealerApi.getDealerShowroomPhone(dealerId),
    onError: (err) => {
      logger.error({
        error: err,
        message: 'Error revealing dealer phone number',
        tags: ['dealer-page', 'reveal-phone'],
      });
    },
  });
};
